import React, { useContext } from 'react';

import { GhostModeContext } from '../../context/GhostMode/GhostMode';
import { User } from '../../utils/user';
import Logo from './Logo';
import NavigationMenu from './NavigationMenu';
import RightBlock from './RightBlock';
import { StyledNavBar } from './styled';
import SubHeaderContent from './SubHeaderContent';

export type HeaderProps = {
  isNotLoggedInMarketerUser: boolean;
};

const Header = ({ isNotLoggedInMarketerUser }: HeaderProps): JSX.Element => {
  const { isGhostMode } = useContext(GhostModeContext);
  const idToken = User.getUserInfo()?.idToken;

  const showGhostModeHeader = isGhostMode && idToken;

  return (
    <>
      <StyledNavBar
        logo={<Logo />}
        rightChildren={[
          <NavigationMenu key="navigation-menu" isNotLoggedInMarketerUser={isNotLoggedInMarketerUser} />,
          <RightBlock key="right-block" />,
        ]}
      />
      {showGhostModeHeader && <SubHeaderContent />}
    </>
  );
};

export default Header;
